export default __webpack_public_path__ + "static/media/me.67b880c8.jpg";